export const ERROR_ALERT_TEXT = 'We\'re unable to process your request. Please try again later.';

const isSsr = typeof window === 'undefined';

export function setupAnalytics() {
  if (!isSsr && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('myPreferenceCenter.static.page-load');
  }
}

export function addAnalyticEvent(event) {
  if (!isSsr) {
    let dd = window.digitalData;
    if (dd) {
      if (!dd.event) {
        dd.event = [];
      }
      dd.event.push(event);
    }
  }
}

export function analyticEvent(settings) {
  return {
    category: {
      primaryCategory: 'button submission'
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings
    }
  };
}

export function overlayEvent(name) {
  return {
    category: {
      primaryCategory: 'overlay'
    },
    eventInfo: {
      eventName: name,
    }
  };
}
